module.exports = "<component-handler loaded=\"CpeCatalogCalendarCtrl.loaded\" error=\"CpeCatalogCalendarCtrl.error\"></component-handler>\n<no-content ng-if=\"CpeCatalogCalendarCtrl.loaded && !CpeCatalogCalendarCtrl.eventSources[0].length\" body=\"'No matching results'\">\n</no-content>\n<div ng-if=\"CpeCatalogCalendarCtrl.loaded && CpeCatalogCalendarCtrl.eventSources[0].length\"\n     id=\"calendar\"\n     ui-calendar=\"CpeCatalogCalendarCtrl.uiConfig.calendar\"\n     ng-model=\"CpeCatalogCalendarCtrl.eventSources\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cpeCatalog/calendar/template.html
// module id = 1342
// module chunks = 0